import { Injectable } from '@angular/core';
import { User } from '../model/user';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private userkey: string = '';
    
    constructor ()   {}



    setUser( user: User ): void { 
        this.userkey = user.userKey;
        localStorage.setItem('user', JSON.stringify( user ) ); 
    }

    getUser(): User {
        let usr:any = localStorage.getItem('user'); 
        if ( usr === undefined || usr === null  ) {
            return User.getEmpty();
        } else {
            return JSON.parse( usr );
        }
    }    

    setAzureUserName(azureUserName?:string): void {
        let usr = this.getUser();
        usr.azureUserName = azureUserName ? azureUserName : '';
        localStorage.setItem('user', JSON.stringify(usr) ); 
    }


    setGlobalID(id:string) {
        let usr = this.getUser();
        usr.id = id;
        localStorage.setItem('user', JSON.stringify(usr) ); 
    }    

    isAdminUSer(): boolean {
        return this.getUser().accessFeatures.includes('sysadmin');
    }

    isStatUser(): boolean {
        return this.getUser().accessFeatures.includes('statistics');
    }

    isActingAsOtherUser(): boolean {
        return this.getUser().actsAsOtherUser;
    }

    logout(): void {
        localStorage.removeItem( 'user' );
        localStorage.removeItem( "userkey" );
    }    
}
